<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    @click:outside="cancel"
    class="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>{{ type === 'update' ? 'SỬA' : 'THÊM' }} CÂU LẠC BỘ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-form ref="form" flat class="pa-3">
        <h3>1. Thông tin cơ bản</h3>
        <v-col cols="12" md="12" class="pb-0">
          <v-text-field
            v-model="name"
            label="Tên câu lạc bộ"
            outlined
            required
            dense
            class="required"
            :rules="[$rules.required]"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pb-0">
          <v-text-field
            v-model="maxMembers"
            label="Số lượng thành viên tối đa"
            outlined
            required
            type="number"
            dense
            class="required"
            :rules="[$rules.required]"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pb-0">
          <v-textarea v-model="description" label="Mô tả" outlined required dense> </v-textarea>
        </v-col>
        <h3>2. Đối tượng áp dụng</h3>
        <v-radio-group v-model="applyFor">
          <v-radio v-for="item in applyOptions" :key="item.value" :label="item.title" :value="item.value"></v-radio>
        </v-radio-group>
        <div v-if="applyFor === 'target'">
          <div>
            <v-chip
              class="mr-2"
              v-for="(item, index) in listTarget"
              :key="index"
              close
              @click:close="removeTarget(item.id)"
            >
              {{ item.title || '' }}
            </v-chip>
          </div>
          <v-btn class="mt-4" small depressed @click="$refs.popupChoseTarget.openDialog()">
            <v-icon left>add</v-icon>Thêm đối tượng áp dụng</v-btn
          >
        </div>
        <PopupSurveyStudentImport
          v-show="applyFor === 'specific'"
          @on-student-import="ev => (students = ev)"
          ref="excel-import"
        />
      </v-form>
      <v-divider />
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed class="px-6 mr-2 white--text" color="primary " @click="save">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
    <PopupChoseTarget ref="popupChoseTarget" @onSave="addTarget" />
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import PopupSurveyStudentImport from '../../survey/survey/PopupSurveyStudentImport.vue'
import PopupChoseTarget from '../../survey/survey/PopupSurvey/PopupChoseTarget.vue'
export default {
  components: { PopupSurveyStudentImport, PopupChoseTarget },
  data() {
    return {
      dialog: false,
      id: '',
      type: '',
      name: '',
      description: '',
      maxMembers: null,
      applyFor: 'all',
      applyOptions: [
        { title: 'Toàn trường', value: 'all' },
        { title: 'Cấp/Khối/Lớp', value: 'target' },
        { title: 'Học sinh', value: 'specific' }
      ],
      listTarget: [],
      students: []
    }
  },
  methods: {
    ...mapActions({ fetchOne: 'club/fetchOne', create: 'club/create', update: 'club/update' }),
    ...mapMutations({ setState: 'club/setState' }),
    openDialog(type, item) {
      if (type === 'update') {
        this.id = item.id
        this.name = item.name
        this.description = item.description
        this.maxMembers = item.maxMembers
        this.applyFor = item.applyFor
        if (item.applyFor === 'target') {
          const targets = []
          targets.push(...item.academicLevels.map(i => ({ id: i.id, title: i.title, type: 'academicLevel' })))
          targets.push(...item.grades.map(i => ({ id: i.id, title: i.title, type: 'grade' })))
          targets.push(...item.classes.map(i => ({ id: i.id, title: i.title, type: 'class' })))
          this.listTarget = targets
        } else if (item.applyFor === 'specific') {
          this.students = item.students
        }
      }
      this.type = type
      this.dialog = true
      this.$nextTick(async () => {
        if (item.applyFor === 'specific') await this.$refs['excel-import'].init(item.students)
      })
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.$refs['excel-import'].reset()
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    addTarget(data) {
      this.listTarget.push(data)
    },
    removeTarget(id) {
      this.listTarget = this.listTarget.filter(item => item.id !== id)
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          const data = {
            name: this.name,
            maxMembers: this.maxMembers,
            description: this.description,
            applyFor: this.applyFor
          }
          if (this.description) data.description = this.description

          if (this.applyFor === 'target') {
            data.academicLevels = this.listTarget.filter(i => i.type === 'academicLevel').map(i => i.id)
            data.grades = this.listTarget.filter(i => i.type === 'grade').map(i => i.id)
            data.classes = this.listTarget.filter(i => i.type === 'class').map(i => i.id)
            data.students = null
          } else if (this.applyFor === 'specific') {
            data.students = this.students
          } else {
            data.academicLevels = null
            data.grades = null
            data.classes = null
            data.students = null
          }

          if (this.type === 'update') {
            await this.update({ id: this.id, ...data })
            await this.fetchOne(this.id)
            this.$alert.success('Chỉnh sửa thành công')
          } else {
            const item = await this.create(data)
            this.$router.push(`/club-detail/${item.id}`)
          }
          this.cancel()
        } catch (error) {
          this.$alert.error(error)
        } finally {
          this.$loading.active = false
        }
      }
    }
  }
}
</script>
